import { Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import * as React from "react";
import { TSetUrlParamsArgs } from "../../../../hooks/useXoraia";
import { generateBorder } from "../../../../lib/generateBorder";
import { ColorPickerProps } from "../../../../utils/interfaces/core/ColorPickerProps";

const ColorPicker: React.FC<
  ColorPickerProps & {
    slug: string;

    onChange: (args: TSetUrlParamsArgs) => Promise<void>;

    urlParams?: TSetUrlParamsArgs;
  }
> = ({
  colorPickerBorder = { width: "2px" },
  colorPickerColors = ["#FFFFFF", "#000000"],
  colorPickerSize = "40px",
  onChange,
  slug,
  urlParams = {},
}) => {
  const [color, setColor] = React.useState<string>(
    urlParams[slug] ? urlParams[slug] : colorPickerColors[0] ?? "#FFFFFF"
  );

  return (
    <ToggleButtonGroup
      exclusive
      value={color}
      onChange={async (_, _color) => {
        setColor(_color);

        await onChange({ [slug]: _color });
      }}
      className="XProductDetails_ColorPicker"
      sx={{
        "&.XProductDetails_ColorPicker": {
          borderRadius: 0,

          "& .MuiToggleButton-root": {
            borderWidth: 0,
            p: "3px",
            bgcolor: "transparent",
            width: colorPickerSize,
            height: colorPickerSize,
            borderRadius: "50% !important",

            "& .XProductDetails_ColorPicker_Color": {
              borderRadius: "50%",
              border: "1px solid #ddd !important",
            },

            "&.Mui-selected": {
              border: generateBorder(colorPickerBorder),
            },

            "&:not(:first-of-type)": {
              ml: 1,
            },
          },
        },
      }}
    >
      {colorPickerColors.map((c) => (
        <ToggleButton key={c} value={c} disableRipple>
          <Stack
            className="XProductDetails_ColorPicker_Color"
            bgcolor={c}
            width="100%"
            height="100%"
          />
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ColorPicker;
